import {
  type Market,
  Pairs,
  PortfolioSymbol,
  UnderlyingSymbol,
} from "#/types/markets";

export const underlyingSymbols: UnderlyingSymbol[] = [
  PortfolioSymbol.BTC,
  PortfolioSymbol.ETH,
];

export const defaultUnderlying: UnderlyingSymbol = PortfolioSymbol.ETH;

export const marketList: Market[] = [
  { underlying: PortfolioSymbol.BTC, pair: Pairs.BTC },
  { underlying: PortfolioSymbol.ETH, pair: Pairs.ETH },
];

export const defaultMarket: Market = marketList[1];
